import _ from 'lodash';

import type { PayeurType } from '@/types';
import * as utils_string from './string';

/**
 * Identité d'un payeur au format officiel : « M. DUPONTELLI Henri »
 * (abréviation de civilité + nom en capitales + prénom).
 */
export const formatPayeurLabel = (payeur?: PayeurType): string => {
  if (_.isNil(payeur)) return '';

  const { nom, prenom, civilite } = payeur;

  return _.trim(
    `${civilite?.abreviation || ''} ${utils_string.toOfficialLastname(nom || '')} ${utils_string.toOfficialFirstname(prenom || '')}`,
  );
};

/**
 * Adresse d'un payeur sur deux lignes :
 *  - ligne 1 : n° de voirie + libellé de voie (« 31 rue du Commerce »)
 *  - ligne 2 : code postal + localité (« 31300 Toulouse »)
 * Les lignes vides sont omises.
 */
export const formatPayeurAdresseLignes = (payeur?: PayeurType): string[] => {
  const adresse = payeur?.adresse;

  if (_.isNil(adresse)) return [];

  const ligneVoie = _.trim(
    _.join(
      _.compact([
        _.isNumber(adresse.numeroVoirie) && adresse.numeroVoirie !== 0
          ? adresse.numeroVoirie
          : null,
        adresse.lettre,
        adresse.complementNumeroVoirie,
        adresse.libelleVoie,
      ]),
      ' ',
    ),
  );

  const ligneVille = _.trim(_.join(_.compact([adresse.numeroCodePostal, adresse.localite]), ' '));

  return _.compact([ligneVoie, ligneVille]);
};
